module.exports = __webpack_public_path__ + "c71d48a6631e0dc785d1d621aa0df8e7.MP3";